import { Alert, Button, Chip, Divider, Grid, IconButton, InputAdornment, MenuItem, Select, Skeleton, Tab, Table, TableBody, TableCell, TableHead, TableRow, Tabs, TextField, tableCellClasses } from '@mui/material';
import { FC, useCallback, useEffect, useState } from 'react';

import EditIcon from '@mui/icons-material/Edit';
import Box from '@mui/material/Box';
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { PermissionsEnum } from "../../utils/auth.types";

import NavigateBeforeOutlinedIcon from '@mui/icons-material/NavigateBeforeOutlined';
import { fetchInventories, fetchInventoryById, fetchSkuHistoryBySkuId } from '../../store/inventoryStore/inventoryThunk';

import styled_ from "@emotion/styled";
import { makeStyles } from '@material-ui/core';
import CheckIcon from '@mui/icons-material/Check';
import CrossIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import MobileStepper from '@mui/material/MobileStepper';
import { styled, useTheme } from '@mui/material/styles';
import { SearchIcon } from 'lucide-react';
import { useNavigate, useParams } from "react-router-dom";
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
import { Utils } from '../../utils/common-utils';
import { TabPanel } from '../Dialog/TabPanel';
// Adjust Stock & Party Wise sections are disabled on the view page for now.
// import AdjustStock from './AdjustStock';
// import PartyPrice from './PartyPrice';
import DefaultImg from './product.png';
import PrintIcon from '@mui/icons-material/Print';
import SkuBarcodePanel from './SkuBarcodePanel';
import BarcodeLabelDrawer from './BarcodeLabelDrawer';
import { useUnitName } from './pickers/useUnitName';
import { fetchStockLevels, fetchStockMovements } from '../../store/stockStore/stockThunk';
import { movementReasonLabel } from '../../utils/inventoryConstants';
import axios from '../../utils/axios';


const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const images = [
  {
    label: 'San Francisco – Oakland Bay Bridge, United States',
    imgPath:
      'https://images.unsplash.com/photo-1537944434965-cf4679d1a598?auto=format&fit=crop&w=400&h=250&q=60',
  },
  {
    label: 'Bird',
    imgPath:
      'https://images.unsplash.com/photo-1538032746644-0212e812a9e7?auto=format&fit=crop&w=400&h=250&q=60',
  },
  {
    label: 'Bali, Indonesia',
    imgPath:
      'https://images.unsplash.com/photo-1537996194471-e657df975ab4?auto=format&fit=crop&w=400&h=250',
  },
  {
    label: 'Goč, Serbia',
    imgPath:
      'https://images.unsplash.com/photo-1512341689857-198e7e2f3ca8?auto=format&fit=crop&w=400&h=250&q=60',
  },
];

const StyledTableCell = styled_(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: '#fff',
      color: '#9da7b7',
      borderTop: '0.25px solid #d9d4d4',
      borderBottom: '0.25px solid #d9d4d4',
      margin:0,
      padding:5,
      fontSize: 13,
      paddingLeft:'15px !important',
    },
    [`&.${tableCellClasses.footer}`]: {
      backgroundColor: '#f5f5f5',
      color: 'black',
      borderTop: '0.25px solid #d9d4d4',
      borderBottom: '0.25px solid #d9d4d4',
      left: 0,
      bottom: 0, // <-- KEY
      zIndex: 2,
      position: 'sticky'
    },
    [`&.${tableCellClasses.body}`]: {
      verticalAlign: 'super',
      fontSize: 14,
      fontWeight:'normal',
      color:'#292d35',
      padding: 5,
      border:'none',
      paddingLeft:'15px !important',
      margin:0
    },
  }));
  
  const StyledTableRow = styled_(TableRow)(({ theme }) => ({
    '&:nth-of-type(even)': {
      backgroundColor: '#fbfbfb',
      // border: '0.5px dashed #9da7b7',
    },
    '&:nth-of-type(odd)': {
        backgroundColor: '#e9ecf1',
        // border: '0.5px dashed #9da7b7',
    },
    // hide last border
    '&:last-child td, &:last-child th': {
    },
  }));

  
  interface StyledTabsProps {
    children?: React.ReactNode;
    value: number;
    onChange: (event: React.SyntheticEvent, newValue: number) => void;
  }
  
  
  const StyledTabs = styled((props: StyledTabsProps) => (
    <Tabs
      {...props}
    />
  ))({
    backgroundColor: '#fafafaff',
    borderRadius: '12px',
    marginLeft: '10px',
    padding: '6px',
    minHeight: '48px',
    maxWidth: 'fit-content',
    '& .MuiTabs-flexContainer': {
      gap: '4px',
    },
    '& .MuiTabs-indicator': {
      display: 'none',
    },
    '& .MuiTab-root': {
      textTransform: 'none',
      fontSize: '14px',
      fontWeight: 500,
      color: '#a0aec0',
      zIndex: 2,
      minWidth: 'auto',
      height: '36px',
      minHeight: '36px',
      padding: '8px 20px',
      borderRadius: '8px',
      transition: 'all 0.2s ease-in-out',
      '&:hover:not(.Mui-selected)': {
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        color: '#059669',
      },
      '&.Mui-selected': {
        backgroundColor: '#059669',
        color: '#ffffff',
        fontWeight: 600,
        boxShadow: '0 2px 8px rgba(5, 150, 105, 0.3)',
      },
    },
  });
  
  interface StyledTabProps {
    label: string;
  }
  
  const StyledTab = styled((props: StyledTabProps) => (
    <Tab disableRipple {...props} />
  ))(({ theme }) => ({
    textTransform: 'none',
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.pxToRem(15),
    marginRight: theme.spacing(1),
    color: '#545454',
    '&.Mui-selected': {
      color: '#059669',
    },
    '&.Mui-focusVisible': {
      backgroundColor: 'rgba(100, 95, 228, 0.32)',
    },
  }));

  interface TabPanelProps {
    index: number;
    value: number;
  }
  
  const StyledTabPanel = styled((props: TabPanelProps) => (
    <TabPanel
      {...props}
    />
  ))({
    '& .MuiBox-root': {
      backgroundColor: 'transparent !important',
      padding: '0px !important'
    }
  });


interface InventoryViewProps {
    accountId?: string;
    inventoryId?: string;
}

const useStyles = makeStyles({
    paper: {
      border: "1.5px solid #e9ecf1",
      boxShadow: 'none',
      borderRadius: 7
    },
    toggleButtonGroup: {
      width: '100%',
    },
    toggleButton: {
      width: 15,
      height: 15,
      marginBottom: 2
    },
  
  });

  

const InventoryViewPage: FC<InventoryViewProps> = (props) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { inventoryId } = useParams();
  
  const classes = useStyles();
  const { inventories, status } = useAppSelector(state => state.inventories);
  const invenotryDetails = useAppSelector(state => state.inventories.inventoryDeatils);
  const { permissions, selectedAccount } = useAppSelector(state => state.auth);
  
  const [stock, setStock] = useState(false);
  const [selectedInventory, setSelectedInventory] = useState<any>();
  const [partyPrice, setPartyPrice] = useState(false);
  // const [inventoryId, setInventory] = useState('');
  const [fetchData, setFetchData] = useState('');
  const canUpdateAccount = permissions?.includes(PermissionsEnum.Account_Update);
  const [stockHistory, setStockHistory] = useState<any[]>([]);

  // Barcode tab — same panel as the inventory form (view/generate codes) plus
  // the listing's label designer drawer for printing.
  const [barcodeMode, setBarcodeMode] = useState('none');
  const [manufacturerBarcode, setManufacturerBarcode] = useState('');
  const [labelDrawerOpen, setLabelDrawerOpen] = useState(false);

  // Resolves MeasuringUnit ids to names (for base unit / pack conversions).
  const unitName = useUnitName();

  // Stock Details tab — this item's on-hand levels & movements (stock store).
  // Shown as On-Hand / Movements sub-tabs, same as the inventory Stock page.
  const { levels: stockLevels, movements: stockMovements } = useAppSelector(state => state.stock);
  const [stockTab, setStockTab] = useState(0); // 0 = on-hand, 1 = movements
  // GRN tab — goods receipts that contain this item.
  const [grns, setGrns] = useState<any[]>([]);
  const [grnsLoading, setGrnsLoading] = useState(false);

  const [value, setValue] = useState(0);

  const [isLoading, setIsLoading] = useState(false);
  const [filterQuery, setFilterQuery] = useState('');

  const handleBackButtonClick = useCallback(() => {
    //Call edit function
    let navLink = `/inventory`;
    navigate(navLink);

  }, []);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const theme = useTheme();
  const [activeStep, setActiveStep] = useState(0);

  const maxSteps = images.length;

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStepChange = (step: number) => {
    setActiveStep(step);
  };

    /**
    * Handler for account name click.
    */
    const handleEditInventoryClick = useCallback((_id: any) => {
        //Call edit function
        let navLink = `/inventory/edit/${_id}`;
        navigate(navLink);

    }, []);

    const stockProps  ={
        visible: stock,
        setVisible: setStock
    }

    /**
    * Handler for New Inventory button click.
    */
    const handleCreateButtonClick= () => {
        const navLink = `/inventory/create`;
        navigate(navLink);
    };

    /**
      * Fetch all the accounts on Accounts page load.
      */
    useEffect(() => {
        const { _id: id } = selectedAccount;
        dispatch(fetchInventories({accountId: id, type: '', params: '' }));
    }, [dispatch, selectedAccount]);

    // fetch current inventory details
    useEffect(() => {
      if (inventoryId) {
        dispatch(fetchInventoryById(inventoryId));
      }
    }, [inventoryId, dispatch]);

    // Check status     
    const checkStatus = useCallback((value) => {
        return (value == 'Active') ? <Chip label={<CheckIcon style={{color:'#49a563',fontSize:22,marginLeft:-5,marginTop:5}}/>} style={{color:'#49a563',backgroundColor:'#edf6ef',border:'1px solid #49a563',borderRadius:25,width:35, height:35 }}/>
         : <Chip label={<CrossIcon style={{color:'#c33b3b',fontSize:22,marginLeft:-5,marginTop:5}}/>} style={{color:'#c33b3b',backgroundColor:'#fbecec',border:'1px solid #c33b3b',borderRadius:25,width:35, height:35 }}/>;
    }, []);

    const filterOnChangeHandler = (data: any) => {
        console.log("filter date from invoice listing ===== ", data);
        // setFilters(data);
    };

    // Old SKU stock-history table — replaced by the embedded Stock view (same as
    // the inventory Stock page). Kept for reference.
    // useEffect(() => {
    //   if(invenotryDetails && invenotryDetails._id) {
    //     fetchSkuHistory();
    //   }
    // }, [invenotryDetails, stock]);

    // const fetchSkuHistory = async () => {
    //   if(invenotryDetails && invenotryDetails._id) {
    //     await dispatch(fetchSkuHistoryBySkuId(invenotryDetails._id)).unwrap().then((data) => {
    //       if (data) {
    //         setStockHistory(data);
    //       }
    //     });
    //   }
    // };

    // Seed the barcode panel's type from the saved SKU (same as the form does).
    useEffect(() => {
      setBarcodeMode((invenotryDetails as any)?.barcodeMode || 'none');
      setManufacturerBarcode('');
    }, [invenotryDetails]);

    // Load this item's stock levels / movements and its GRNs for the tabs.
    useEffect(() => {
      const id = invenotryDetails?._id;
      if (!id) return;
      dispatch(fetchStockLevels(`skuId=${id}&limit=100`));
      dispatch(fetchStockMovements(`skuId=${id}&limit=50`));
      setGrnsLoading(true);
      axios.get(`/api/v1/erp/grns?skuId=${id}&limit=50`)
        .then((res) => setGrns(res.data?.data || []))
        .catch(() => setGrns([]))
        .finally(() => setGrnsLoading(false));
    }, [invenotryDetails?._id, dispatch]);

    // GRN rows flattened to THIS item's lines only (one row per receipt line).
    const grnRows = grns.flatMap((g: any) =>
      (g.items || [])
        .filter((it: any) => String(it?.skuId?._id || it?.skuId || '') === String(invenotryDetails?._id || ''))
        .map((it: any, idx: number) => ({ g, it, key: `${g._id}-${idx}` }))
    );

    // Base (stock) unit display name — populated object, cached name, or id via the
    // units master. Falls back to the legacy sale unit code for old items.
    const baseUnit: any = (invenotryDetails as any)?.baseUnit;
    const baseUnitName: string =
      (baseUnit && typeof baseUnit === 'object' && (baseUnit.name || baseUnit.code)) ||
      (invenotryDetails as any)?.baseUnitName ||
      (baseUnit ? unitName(String(baseUnit)) : '') ||
      (invenotryDetails?.sale?.unit?.code || '');

    const unitConversions: Record<string, number> = (invenotryDetails as any)?.unitConversions || {};

    useEffect(() => {
      fetchInventory();
    }, [dispatch, selectedAccount, filterQuery]);
  
  
    const fetchInventory = async () => {
      const { _id: id } = selectedAccount;
      if(filterQuery) {
        let filter = (filterQuery && filterQuery !== '') ? `&name=${filterQuery}` : '';
        await dispatch(fetchInventories({ accountId: id, type: '', params: filter }));
        setIsLoading(false);
      } else {
        await dispatch(fetchInventories({ accountId: id, type: '', params: filterQuery }));
        setIsLoading(false);
      }
    }

    const searchQuery = async (searchValue:string)=> {
      setIsLoading(true);
      setFilterQuery(searchValue);
    }

    return (
      <>
        {/* Adjust Stock & Party Wise Price drawers — disabled on the view page for now */}
        {/* <AdjustStock selectedData={selectedInventory} setVisible={setStock} visible={stock}/> */}
        {/* <PartyPrice setVisible={setPartyPrice} visible={partyPrice}/> */}

        {/* Same barcode label designer as the inventory listing */}
        {invenotryDetails && invenotryDetails._id && (
          <BarcodeLabelDrawer
            open={labelDrawerOpen}
            onClose={() => setLabelDrawerOpen(false)}
            accountId={selectedAccount?._id}
            item={{
              _id: invenotryDetails._id,
              name: invenotryDetails.name,
              itemCode: invenotryDetails.itemCode,
              hsnCode: invenotryDetails.hsnCode,
              mrp: invenotryDetails.mrp,
              salePrice: invenotryDetails.sale?.price,
              unitCode: invenotryDetails.sale?.unit?.code,
              baseUnit: (invenotryDetails as any).baseUnit,
              baseUnitName: (invenotryDetails as any).baseUnitName,
              unitConversions: (invenotryDetails as any).unitConversions,
              barcodeMode: (invenotryDetails as any).barcodeMode,
            }}
            companyInfo={{
              name: selectedAccount?.displayName || selectedAccount?.name,
              phone: selectedAccount?.whatsAppNumber,
              customerCare: selectedAccount?.whatsAppNumber || selectedAccount?.email,
            }}
          />
        )}

        {/* Old Header Bar - Commented for new layout */}
        {/* <Grid container p={0} spacing={2} position={'fixed'} mt={-2} zIndex={0}>
          <Grid item xs={8} >
            <Box component="form" noValidate sx={{borderRadius:'12px', border:'3px solid #e9ecf1',backgroundColor:'#fff'}}>
              <Grid container>
                <Grid {...{ xs: 12, sm: 8, md: 4, lg: 12, p:2, pl:2,pt:1.5, bgcolor:'#e9ecf1' }} style={{borderTopLeftRadius:8,borderTopRightRadius:8,height:50}} >
                  <div style={{float:'right',marginTop:-5,marginRight:-5}}>
                    {invenotryDetails.itemType == "Product" &&
                    <Button
                      size='small'
                      onClick={()=> {setStock(true); setSelectedInventory(invenotryDetails);}}
                      variant="contained"
                      style={{ color:'#488dff',backgroundColor:'#fff',border:'0.5px solid #488dff',height:35,borderRadius:7, marginRight:10}}>
                      Adjust Stock
                    </Button>
                    }
                    <IconButton
                        style={{color:'#488dff',backgroundColor:'#fff',border:'0.1px solid #488dff',height:35,width:35, marginRight:10}}
                        size='small' onClick={() => handleEditInventoryClick(inventoryId)}><EditIcon style={{fontSize:16}}/>
                    </IconButton>
                    <IconButton
                        style={{color:'#c33b3b',backgroundColor:'#fff',border:'0.1px solid #c33b3b',height:35,width:35 }}
                        size='small' ><DeleteIcon style={{fontSize:16}}/>
                    </IconButton>
                  </div>
                  <IconButton onClick={() => handleBackButtonClick()} style={{float:'left', color:'#545454',backgroundColor:'#f5f5f5',border:'none',height:35,width:35,marginTop:-5,marginRight:10,marginLeft:-5 }} size='small' >
                    <NavigateBeforeOutlinedIcon style={{fontSize:20}} />
                  </IconButton>
                  <h3  style={{marginTop:-1,fontWeight:600}}>{String(invenotryDetails.name).length > 70 ? String(invenotryDetails.name).substring(0,68) + '...' : String(invenotryDetails.name)}</h3>
                </Grid>
              </Grid>

          </Box>
          </Grid>
        </Grid> */}

        <Grid container p={0} spacing={2} pt={0} >
          <Grid item xs={9}>
            <Box sx={{ bgcolor: '' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <StyledTabs
                  value={value}
                  onChange={handleChange}
                  aria-label="styled tabs example">
                  <StyledTab label="Item Details"/>
                  <StyledTab label="Stock Details" />
                  <StyledTab label="GRN" />
                  <StyledTab label="Product Barcode" />
                  {/* Party Wise sections disabled for now */}
                  {/* <StyledTab label="Party Wise Report" /> */}
                  {/* <StyledTab label="Party Wise Price" /> */}
                </StyledTabs>
                <div style={{display:'flex', gap:'8px', marginRight:'10px'}}>
                  {/* Adjust Stock disabled on the view page — use the Stock page instead */}
                  {/* {invenotryDetails.itemType == "Product" &&
                  <Button
                    size='small'
                    onClick={()=> {setStock(true); setSelectedInventory(invenotryDetails);}}
                    variant="contained"
                    style={{ color:'#488dff',backgroundColor:'#fff',border:'0.5px solid #488dff',height:35,borderRadius:7,whiteSpace:'nowrap'}}>
                    Adjust Stock
                  </Button>
                  } */}
                  <IconButton
                      style={{color:'#488dff',backgroundColor:'#fff',border:'0.1px solid #488dff',height:35,width:35}}
                      size='small' onClick={() => handleEditInventoryClick(inventoryId)}><EditIcon style={{fontSize:16}}/>
                  </IconButton>
                  <IconButton
                      style={{color:'#c33b3b',backgroundColor:'#fff',border:'0.1px solid #c33b3b',height:35,width:35}}
                      size='small' ><DeleteIcon style={{fontSize:16}}/>
                  </IconButton>
                </div>
              </Box>
              <StyledTabPanel value={value} index={0} >
                <Grid container spacing={2} >
                  <Grid item xs={3.5}>
                    <Box sx={{ width:'100%', flexGrow: 1 }} className={'c-card2'}>
                      <AutoPlaySwipeableViews
                        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                        index={activeStep}
                        onChangeIndex={handleStepChange}
                        enableMouseEvents >
                        {images.map((step, index) => (
                        <div key={step.label}>
                          {Math.abs(activeStep - index) <= 2 ? (
                            <Box
                              component="img"
                              sx={{
                              height: 228,
                              display: 'block',
                              overflow: 'hidden',
                              borderTopLeftRadius:'15px',
                              borderTopRightRadius:'15px',
                              width: '100%',
                              objectFit: 'cover'
                              }}
                              src={step.imgPath}
                              alt={step.label}
                            />
                          ) : null}
                        </div>
                        ))}
                      </AutoPlaySwipeableViews>
                      <MobileStepper
                        steps={maxSteps}
                        position="static"
                        style={{borderBottomLeftRadius:'15px',
                        borderBottomRightRadius:'15px',}}
                        activeStep={activeStep}
                        nextButton={
                          <IconButton
                            onClick={handleNext}
                            disabled={activeStep === maxSteps - 1}
                            style={{color:'#545454',backgroundColor:'#f5f5f5',border:'none',height:35,width:35 }}
                            size='small' >
                            {theme.direction === 'rtl' ? (
                            <KeyboardArrowLeft style={{fontSize:20}}/>
                            ) : (
                            <KeyboardArrowRight style={{fontSize:20}}/>
                            )}
                          </IconButton>
                        }
                        backButton={
                          <IconButton
                            onClick={handleBack}
                            disabled={activeStep === 0}
                            style={{color:'#545454',backgroundColor:'#f5f5f5',border:'none',height:35,width:35 }}
                            size='small' >
                            {theme.direction === 'rtl' ? (
                            <KeyboardArrowRight style={{fontSize:20}}/>
                            ) : (
                            <KeyboardArrowLeft style={{fontSize:20}}/>
                            )}
                          </IconButton>
                        }
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={8.5}>
                    <div className={'c-card2'} style={{padding:15,paddingTop:10}}>
                      <h5 style={{fontWeight:'bold',color:'#000',fontSize:15}}>General Details</h5>
                      {/* {JSON.stringify(selectedInventory)} */}
                      <Divider sx={{mt:0.5,mb:1}}/>
                      <h5 style={{fontWeight:'normal',color:'#9da7b7',fontSize:13}}>Item Name</h5>
                      <h5 style={{fontWeight:'normal',color:'#000',fontSize:14,marginBottom:10}}>
                        {String(invenotryDetails.name).length > 70 ? String(invenotryDetails.name).substring(0,68) + '...' : String(invenotryDetails.name)}
                      </h5>
                      <Grid container spacing={2}>
                        <Grid item xs={3}>
                          <h5 style={{fontWeight:'normal',color:'#9da7b7',fontSize:13}}>{invenotryDetails.itemType === 'Product' ? 'Item Short' : 'Service Short'}</h5>
                          <h5 style={{fontWeight:'normal',color:'#000',fontSize:14,marginBottom:3}}>{(invenotryDetails && invenotryDetails.itemShort) ? invenotryDetails.itemShort : '-'}</h5>
                        </Grid>
                        <Grid item xs={3}>
                          <h5 style={{fontWeight:'normal',color:'#9da7b7',fontSize:13}}>{invenotryDetails.itemType === 'Product' ? 'Item Code' : 'Service Code'}</h5>
                          <h5 style={{fontWeight:'normal',color:'#000',fontSize:14,marginBottom:3}}>{(invenotryDetails && invenotryDetails.itemCode) ? invenotryDetails.itemCode : '-'}</h5>
                        </Grid>
                        <Grid item xs={3}>
                          <h5 style={{fontWeight:'normal',color:'#9da7b7',fontSize:13}}>Category</h5>
                          <h5 style={{fontWeight:'normal',color:'#000',fontSize:14,marginBottom:3}}>{(invenotryDetails && invenotryDetails.category) ? invenotryDetails.category.name : '-'}</h5>
                        </Grid>
                        <Grid item xs={3}>
                          <h5 style={{fontWeight:'normal',color:'#9da7b7',fontSize:13}}>Sub Category</h5>
                          <h5 style={{fontWeight:'normal',color:'#000',fontSize:14,marginBottom:3}}>{(invenotryDetails && invenotryDetails.subCategory) ? invenotryDetails.subCategory.name : '-'}</h5>
                        </Grid>
                        <Grid item xs={12}>
                          <Grid container spacing={2}>
                            <Grid item xs={3}>
                              <h5 style={{fontWeight:'normal',color:'#9da7b7',fontSize:13}}>Item Type</h5>
                              <h5 style={{fontWeight:'normal',color:'#000',fontSize:14,marginBottom:3}}>{invenotryDetails.itemType}</h5>
                            </Grid>
                            <Grid item xs={3}>
                              <h5 style={{fontWeight:'normal',color:'#9da7b7',fontSize:13}}>Base Unit</h5>
                              <h5 style={{fontWeight:'normal',color:'#000',fontSize:14,marginBottom:3}}>{baseUnitName || '-'}</h5>
                            </Grid>
                            <Grid item xs={6}>
                              <h5 style={{fontWeight:'normal',color:'#9da7b7',fontSize:13}}>Units & Packs (Conversions)</h5>
                              {Object.keys(unitConversions).length > 0 ? Object.entries(unitConversions).map(([uid, factor]) =>
                                <h5 key={uid} style={{fontWeight:'normal',color:'#000',fontSize:14,marginBottom:3,whiteSpace:'normal',wordBreak:'break-word'}}>1 {unitName(uid)} = {String(factor)} {baseUnitName}</h5>
                              ) : <h5 style={{fontWeight:'normal',color:'#000',fontSize:14,marginBottom:3}}>-</h5>}
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </div>
                  </Grid>
                  <Grid item xs={12}>
                                  <div className={'c-card2'} style={{padding:15,paddingTop:10}}>
                                  <h5 style={{fontWeight:'bold',color:'#000',fontSize:15}}>Pricing Details</h5>
                                  <Divider sx={{mt:0.5,mb:1}}/>
                                  <Grid container spacing={2}>
                                      <Grid item xs={3}>
                                      <h5 style={{fontWeight:'normal',color:'#9da7b7',fontSize:13}}>Sales Price</h5>
                                      <h5 style={{fontWeight:'normal',color:'#000',fontSize:14,marginBottom:3}}>{(invenotryDetails && invenotryDetails.sale) ? Utils.formatNumber(invenotryDetails.sale.price) : '-'}</h5>
                                      </Grid>
                                      <Grid item xs={3}>
                                      <h5 style={{fontWeight:'normal',color:'#9da7b7',fontSize:13}}>Purchase Price</h5>
                                      <h5 style={{fontWeight:'normal',color:'#000',fontSize:14,marginBottom:3}}>{(invenotryDetails && invenotryDetails.purchase) ? Utils.formatNumber(invenotryDetails.purchase.price) : '-'}</h5>
                                      </Grid>
                                      <Grid item xs={3}>
                                      <h5 style={{fontWeight:'normal',color:'#9da7b7',fontSize:13}}>MRP</h5>
                                      <h5 style={{fontWeight:'normal',color:'#000',fontSize:14,marginBottom:3}}>{(invenotryDetails && invenotryDetails.mrp) ? Utils.formatNumber(invenotryDetails.mrp) : '-'}</h5>
                                      </Grid>
                                      <Grid item xs={3}>
                                      <h5 style={{fontWeight:'normal',color:'#9da7b7',fontSize:13}}>HSN Code</h5>
                                      <h5 style={{fontWeight:'normal',color:'#000',fontSize:14,marginBottom:3}}>{(invenotryDetails && invenotryDetails.hsnCode) ? `${invenotryDetails.hsnCode}` : '-'}</h5>
                                      </Grid>
                                      {/* <Grid item xs={3}>
                                      <h5 style={{fontWeight:'normal',color:'#9da7b7',fontSize:13}}>Sale Unit</h5>
                                      <h5 style={{fontWeight:'normal',color:'#000',fontSize:14,marginBottom:3}}>{(invenotryDetails && invenotryDetails.sale && invenotryDetails.sale.unit) ? `${invenotryDetails.sale.unit.code}` : '-'}</h5>
                                      </Grid> */}
                                      {/* <Grid item xs={3}>
                                      <h5 style={{fontWeight:'normal',color:'#9da7b7',fontSize:13}}>Purchase Unit</h5>
                                      <h5 style={{fontWeight:'normal',color:'#000',fontSize:14,marginBottom:3}}>{(invenotryDetails && invenotryDetails.purchase && invenotryDetails.purchase.unit) ? `${invenotryDetails.purchase.unit.code}` : '-'}</h5>
                                      </Grid> */}
                                      <Grid item xs={3}>
                                      <h5 style={{fontWeight:'normal',color:'#9da7b7',fontSize:13}}>GST Tax Rate(%)</h5>
                                      <h5 style={{fontWeight:'normal',color:'#000',fontSize:14,marginBottom:3}}>{(invenotryDetails && invenotryDetails.gst) ? `${invenotryDetails.gst.lable}` : '-'}</h5>
                                      </Grid>
                                      <Grid item xs={3}>
                                      <h5 style={{fontWeight:'normal',color:'#9da7b7',fontSize:13}}>WholeSale Price</h5>
                                      <h5 style={{fontWeight:'normal',color:'#000',fontSize:14}}>{(invenotryDetails && invenotryDetails.wholeSale) ? `${invenotryDetails.wholeSale.price}` : '-'}</h5>
                                      </Grid>
                                      <Grid item xs={3}>
                                      <h5 style={{fontWeight:'normal',color:'#9da7b7',fontSize:13}}>Min. Wholesale Quantity</h5>
                                      <h5 style={{fontWeight:'normal',color:'#000',fontSize:14}}>{(invenotryDetails && invenotryDetails.wholeSale) ? `${invenotryDetails.wholeSale.minQty}` : '-'}</h5>
                                      </Grid>
                                      <Grid item xs={3}>
                                      <h5 style={{fontWeight:'normal',color:'#9da7b7',fontSize:13}}>Discount(%)</h5>
                                      <h5 style={{fontWeight:'normal',color:'#000',fontSize:14}}>{(invenotryDetails.discount) && `${invenotryDetails.discount.discountPercent}%`}  {(invenotryDetails.discount) && `(${Utils.formatNumber(invenotryDetails.discount.discountAmount)})`}</h5>
                                      </Grid>
                                  </Grid>
                                  </div>
                  </Grid>
                  {((invenotryDetails as any).variantsEnabled && (invenotryDetails as any).variants && (invenotryDetails as any).variants.length > 0) &&
                  <Grid item xs={12}>
                      <div className={'c-card2'} style={{padding:15,paddingTop:10}}>
                      <h5 style={{fontWeight:'bold',color:'#000',fontSize:15}}>Variants</h5>
                      <Divider sx={{mt:0.5,mb:1}}/>
                      <Grid container spacing={2}>
                        {(invenotryDetails as any).variants.map((v:any, idx:number) =>
                          <Grid item xs={3} key={v._id || idx}>
                            <h5 style={{fontWeight:'normal',color:'#9da7b7',fontSize:13}}>{v.name || `Variant ${idx + 1}`}</h5>
                            <h5 style={{fontWeight:'normal',color:'#000',fontSize:14,marginBottom:3}}>
                              {v.salePriceType === 'percent' ? `${v.salePrice}% of sale price` : Utils.formatNumber(Number(v.salePrice) || 0)}
                            </h5>
                          </Grid>
                        )}
                      </Grid>
                      </div>
                  </Grid>
                  }
                  <Grid item xs={12}>
                      <div className={'c-card2'} style={{padding:15,paddingTop:10}}>
                      <h5 style={{fontWeight:'bold',color:'#000',fontSize:15}}>Tags</h5>
                      <Divider sx={{mt:0.5,mb:1}}/>
                      <Grid container spacing={2}>
                          <Grid item xs={12}>
                            {(invenotryDetails.tags && invenotryDetails.tags.length > 0) ? invenotryDetails.tags.map((e:any) =>
                              <Chip
                                label={e.name}
                                key={e._id}
                                size="small"
                                sx={{ mr: 0.5, mb: 0.5, backgroundColor: e.color || '#7f8c9b', color: '#fff' }}
                              />
                              ) :
                              <h5 style={{fontWeight:'normal',color:'#000',fontSize:14}}>Item is not tagged</h5>
                            }
                          </Grid>
                      </Grid>
                      </div>
                  </Grid>
                  <Grid item xs={12}>
                      <div className={'c-card2'} style={{padding:15,paddingTop:10}}>
                      <h5 style={{fontWeight:'bold',color:'#000',fontSize:15}}>Tags</h5>
                      <Divider sx={{mt:0.5,mb:1}}/>
                      <Grid container spacing={2}>
                          <Grid item xs={12}>
                            {(invenotryDetails.tags && invenotryDetails.tags.length > 0) ? invenotryDetails.tags.map((e:any) =>
                              <Chip
                                label={e.name}
                                key={e._id}
                                size="small"
                                sx={{ mr: 0.5, mb: 0.5, backgroundColor: e.color || '#7f8c9b', color: '#fff' }}
                              />
                              ) :
                              <h5 style={{fontWeight:'normal',color:'#000',fontSize:14}}>Item is not tagged</h5>
                            }
                          </Grid>
                      </Grid>
                      </div>
                  </Grid>
                  <Grid item xs={12}>
                      <div className={'c-card2'} style={{padding:15,paddingTop:10}}>
                      <h5 style={{fontWeight:'bold',color:'#000',fontSize:15}}>Tagged Items</h5>
                      <Divider sx={{mt:0.5,mb:1}}/>
                      <Grid container spacing={2}>
                          <Grid item xs={12}>
                            {(invenotryDetails.parentSkus && invenotryDetails.parentSkus.length > 0) ? invenotryDetails.parentSkus.map((e:any) =>
                              <Chip variant="outlined" label={e.name} key={e._id} />
                              ) :
                              <h5 style={{fontWeight:'normal',color:'#000',fontSize:14}}>Item is not tagged with any other parent sku</h5>
                            }
                          </Grid>

                      </Grid>
                      </div>
                  </Grid>
                </Grid>
            </StyledTabPanel>
                    <StyledTabPanel value={value} index={1} >
                    {/* This item's stock — On-Hand / Movements sub-tabs (same as the Stock page),
                        table in the Buyer view Address tab format */}
                    {(invenotryDetails.itemType === "Product" || invenotryDetails.itemType === "Raw Material") ?
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <div className={'c-card2'} style={{padding:0}}>
                            <Tabs
                              value={stockTab}
                              onChange={(_e, v) => setStockTab(v)}
                              sx={{
                                minHeight: 40, ml: 1,
                                '& .MuiTab-root': { textTransform: 'none', minHeight: 40, fontSize: 14 },
                                '& .Mui-selected': { color: '#059669 !important' },
                                '& .MuiTabs-indicator': { backgroundColor: '#059669' },
                              }}>
                              <Tab label="On-Hand" />
                              <Tab label="Movements" />
                            </Tabs>
                            {stockTab === 0 ?
                              ((stockLevels && stockLevels.length > 0) ?
                              <div style={{marginBottom:12}}>
                                <Table stickyHeader sx={{ width: '100%'}} size='small' aria-label="customized table">
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell>Location</StyledTableCell>
                                        <StyledTableCell>Batch</StyledTableCell>
                                        <StyledTableCell>Expiry</StyledTableCell>
                                        <StyledTableCell>Quantity</StyledTableCell>
                                        <StyledTableCell>Avg Purchase Cost</StyledTableCell>
                                        <StyledTableCell>Reserved</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                  {stockLevels.map((e:any) =>
                                    <StyledTableRow key={e._id}>
                                        <StyledTableCell>{e.locationId?.name || '-'}</StyledTableCell>
                                        <StyledTableCell>{e.batchId?.batchNumber || '-'}</StyledTableCell>
                                        <StyledTableCell>
                                          {e.batchId?.expiryDate ?
                                            <span style={{ color: new Date(e.batchId.expiryDate).getTime() <= Date.now() ? '#c33b3b' : 'inherit' }}>
                                              {Utils.formatDate(e.batchId.expiryDate)}
                                            </span> : '-'}
                                        </StyledTableCell>
                                        <StyledTableCell>{e.quantity ?? 0} {baseUnitName}</StyledTableCell>
                                        <StyledTableCell>{Utils.formatNumber(e.avgPurchaseCost ?? 0)}</StyledTableCell>
                                        <StyledTableCell>{e.reserved ?? 0}</StyledTableCell>
                                    </StyledTableRow>
                                  )}
                                </TableBody>
                                </Table>
                              </div> :
                              <div style={{height:100}}>
                                <Divider sx={{mt:0.5,mb:1}}/>
                                <span style={{marginLeft:15}}>No stock on-hand for this item</span>
                              </div>)
                              :
                              ((stockMovements && stockMovements.length > 0) ?
                              <div style={{marginBottom:12}}>
                                <Table stickyHeader sx={{ width: '100%'}} size='small' aria-label="customized table">
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell>Date</StyledTableCell>
                                        <StyledTableCell>Reason</StyledTableCell>
                                        <StyledTableCell>Location</StyledTableCell>
                                        <StyledTableCell>Batch</StyledTableCell>
                                        <StyledTableCell>Quantity</StyledTableCell>
                                        <StyledTableCell>Balance</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                  {stockMovements.map((e:any) =>
                                    <StyledTableRow key={e._id}>
                                        <StyledTableCell>{Utils.formatDate(e.createdAt)}</StyledTableCell>
                                        <StyledTableCell>{movementReasonLabel(e.reason)}</StyledTableCell>
                                        <StyledTableCell>{e.locationId?.name || '-'}</StyledTableCell>
                                        <StyledTableCell>{e.batchId?.batchNumber || '-'}</StyledTableCell>
                                        <StyledTableCell>
                                          <span style={{ color: (e.qtyDelta || 0) < 0 ? '#c33b3b' : '#49a563' }}>
                                            {(e.qtyDelta || 0) > 0 ? `+${e.qtyDelta}` : e.qtyDelta} {baseUnitName}
                                          </span>
                                        </StyledTableCell>
                                        <StyledTableCell>{e.balanceAfter ?? 0} {baseUnitName}</StyledTableCell>
                                    </StyledTableRow>
                                  )}
                                </TableBody>
                                </Table>
                              </div> :
                              <div style={{height:100}}>
                                <Divider sx={{mt:0.5,mb:1}}/>
                                <span style={{marginLeft:15}}>No stock movements for this item</span>
                              </div>)
                            }
                          </div>
                        </Grid>
                      </Grid>
                      :
                      <Box sx={{ width:'100%', p:1.5 }} className={'c-card2'}>
                        <Alert severity="error" style={{fontSize: 16}}>
                          This Inventory Item is a <b>Service</b> type. Hence we are not maintaining any stock history for the Item.
                        </Alert>
                      </Box>
                    }
                    {/* Old month-filter + SKU stock-history table — replaced by the embedded Stock view above.
                    <Box sx={{ width:'100%' }} className={'c-card2'}>
                        <Grid container p={2} >
                            <Grid xs={8.9} >
                            <Select
                            className='c-text-field-4'
                            disableUnderline
                            MenuProps={{
                              PaperProps: {
                                sx: {
                                  border: "1.5px solid #e9ecf1",
                                  // width: 255,
                                  // marginLeft:'-29px !important',
                                  boxShadow: 'none',
                                  borderRadius: '5px'
                                }
                              }
                              }}
                            style={{width:200}}
                            variant='outlined'
                            sx={{
                              boxShadow: "none",
                              paddingTop:'0px !important',
                              borderRadius:'7px !important',
                              // fontSize:12,
                              '& .MuiOutlinedInput-input': {p: 0.5},
                              // '& .MuiSelect-select': { p:0 },
                              marginBottom:'3px',
                              ".MuiOutlinedInput-notchedOutline": { border: 0 },
                              "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                                {
                                  border: 0,
                                },
                              "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                                {
                                  border: 0,
                                },
                            }}
                            >
                                <MenuItem value={'0'} key={'0'}>Last Month</MenuItem>
                            </Select>
                            </Grid>

                            <Grid xs={2} pr={2}>
                            <Select
                            className='c-text-field-4'
                            disableUnderline
                            MenuProps={{
                              PaperProps: {
                                sx: {
                                  border: "1.5px solid #e9ecf1",
                                  // width: 255,
                                  // marginLeft:'-29px !important',
                                  boxShadow: 'none',
                                  borderRadius: '5px'
                                }
                              }
                              }}
                            style={{width:'100%'}}
                            variant='outlined'
                            sx={{
                              boxShadow: "none",
                              paddingTop:'0px !important',
                              borderRadius:'7px !important',
                              // fontSize:12,
                              '& .MuiOutlinedInput-input': {p: 0.5},
                              // '& .MuiSelect-select': { p:0 },
                              marginBottom:'3px',
                              ".MuiOutlinedInput-notchedOutline": { border: 0 },
                              "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                                {
                                  border: 0,
                                },
                              "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                                {
                                  border: 0,
                                },
                            }}
                            >     
                                <MenuItem value={'0'} key={'0'}>Download</MenuItem>
                            </Select>
                            </Grid>

                            <Grid xs={1.1}>
                            <Button
                                size='small'
                                variant="contained"
                                style={{ color:'#488dff',backgroundColor:'#fff',border:'0.5px solid #488dff',height:35,borderRadius:7, whiteSpace: 'nowrap', }}
                            >
                            Print PDF</Button>
                            </Grid>
                        </Grid>
                        {invenotryDetails.itemType == "Product" ?
                          <div style={{marginBottom:12}}>
                            <Table stickyHeader sx={{ minWidth: 700}} size='small' aria-label="customized table">
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell >Date</StyledTableCell>
                                    <StyledTableCell>Transaction Type</StyledTableCell>
                                    <StyledTableCell>Quantity</StyledTableCell>
                                    <StyledTableCell>Invoice Number</StyledTableCell>
                                    <StyledTableCell>Closing Stock</StyledTableCell>
                                    <StyledTableCell>Remarks</StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                              {(invenotryDetails.itemType == "Product" && stockHistory && stockHistory.length > 0) ? stockHistory.map((e:any) =>
                                <StyledTableRow key={0}>
                                    <StyledTableCell>{Utils.formatDate(e.date)}</StyledTableCell>   
                                    <StyledTableCell>{e.type}</StyledTableCell>   
                                    <StyledTableCell>{e.qty}</StyledTableCell>   
                                    <StyledTableCell>{e.invoiceNumber}</StyledTableCell>  
                                    <StyledTableCell>{e.closingStock} {(invenotryDetails.sale && invenotryDetails.sale.unit) ? invenotryDetails.sale.unit.code : ''}</StyledTableCell>   
                                    <StyledTableCell>{e.remarks || ''}</StyledTableCell>
                                </StyledTableRow>
                                ) :
                                <StyledTableRow key={Math.random().toString()}>
                                    <StyledTableCell>No Stock History Found</StyledTableCell>   
                                    <StyledTableCell></StyledTableCell>   
                                    <StyledTableCell></StyledTableCell>   
                                    <StyledTableCell></StyledTableCell>   
                                    <StyledTableCell></StyledTableCell>   
                                    <StyledTableCell></StyledTableCell>   
                                </StyledTableRow>
                              }
                            </TableBody>
                            </Table>
                          </div> :
                          <div style={{ height: 200 }}>
                            <Divider sx={{ mt: 0.5, mb: 1 }} />
                            <Alert severity="error" style={{fontSize: 16}}>
                              This Inventory Item is a <b>Service</b> type. Hence we are not maintaining any stock history for the Item.
                            </Alert>
                          </div>
                        }
                    </Box>
                    */}
                    </StyledTabPanel>

                    {/* GRN — this item's goods receipts, essential fields only (Buyer Address tab table format) */}
                    <StyledTabPanel value={value} index={2} >
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <div className={'c-card2'} style={{padding:0}}>
                            <h5 style={{fontWeight:'bold',color:'#000',fontSize:15,marginLeft:15,marginTop:10}}>Goods Receipts (GRN)</h5>
                            {grnsLoading ?
                              <div style={{height:100}}>
                                <Divider sx={{mt:0.5,mb:1}}/>
                                <span style={{marginLeft:15}}>Loading…</span>
                              </div> :
                              (grnRows.length > 0) ?
                              <div style={{marginBottom:12,marginTop:5}}>
                                <Table stickyHeader sx={{ width: '100%'}} size='small' aria-label="customized table">
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell>Date</StyledTableCell>
                                        <StyledTableCell>GRN #</StyledTableCell>
                                        <StyledTableCell>Supplier</StyledTableCell>
                                        <StyledTableCell>Location</StyledTableCell>
                                        <StyledTableCell>Status</StyledTableCell>
                                        <StyledTableCell>Batch</StyledTableCell>
                                        <StyledTableCell>Quantity</StyledTableCell>
                                        <StyledTableCell>Purchase Price</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                  {grnRows.map(({ g, it, key }: any) =>
                                    <StyledTableRow key={key}>
                                        <StyledTableCell>{Utils.formatDate(g.createdAt)}</StyledTableCell>
                                        <StyledTableCell>
                                          <span style={{ color:'#488dff', cursor:'pointer' }} onClick={() => navigate(`/inventory/grn/${g._id}`)}>
                                            {g.grnNumber || '-'}
                                          </span>
                                        </StyledTableCell>
                                        <StyledTableCell>{g.supplierId?.name || g.supplierId?.legalName || '-'}</StyledTableCell>
                                        <StyledTableCell>{g.locationId?.name || '-'}</StyledTableCell>
                                        <StyledTableCell>
                                          <Chip size='small' style={{ borderRadius: 7,
                                            color: g.status === 'posted' ? '#49a563' : g.status === 'cancelled' ? '#c33b3b' : '#b08900',
                                            backgroundColor: g.status === 'posted' ? '#edf6ef' : g.status === 'cancelled' ? '#fbecec' : '#fdf6e3' }}
                                            label={String(g.status || '').replace(/\b\w/g, (c:string) => c.toUpperCase())} />
                                        </StyledTableCell>
                                        <StyledTableCell>{it?.batchNumber || '-'}</StyledTableCell>
                                        <StyledTableCell>{Number(it?.qtyReceived ?? 0)} {it?.unit ? unitName(String(it.unit)) : baseUnitName}</StyledTableCell>
                                        <StyledTableCell>{Utils.formatNumber(Number(it?.purchasePrice ?? 0))}</StyledTableCell>
                                    </StyledTableRow>
                                  )}
                                </TableBody>
                                </Table>
                              </div> :
                              <div style={{height:100}}>
                                <Divider sx={{mt:0.5,mb:1}}/>
                                <span style={{marginLeft:15}}>No goods receipts found for this item</span>
                              </div>
                            }
                          </div>
                        </Grid>
                      </Grid>
                    </StyledTabPanel>

                    <StyledTabPanel value={value} index={3} >
                    {/* Product Barcode — same panel as the inventory form (view / generate codes) plus the listing's label designer for printing */}
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <div className={'c-card2'} style={{padding:20}}>
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 15 }}>
                            <h4 style={{fontWeight:'bold',color:'#000',fontSize:18,margin:0}}>Product Barcode</h4>
                            <Button
                              variant="contained"
                              startIcon={<PrintIcon />}
                              onClick={() => setLabelDrawerOpen(true)}
                              sx={{
                                color:'#488dff',backgroundColor:'#fff',border:'0.5px solid #488dff',height:35,
                                textTransform: 'none',
                                fontWeight: 500,
                                fontSize: '14px',
                                padding: '8px 16px'
                              }}
                            >
                              Print Barcode Labels
                            </Button>
                          </div>
                          <Divider sx={{mt:0.5,mb:2}}/>
                          <Grid container spacing={2}>
                            {invenotryDetails._id ?
                              <SkuBarcodePanel
                                isEditing={true}
                                skuId={invenotryDetails._id}
                                mode={barcodeMode}
                                onModeChange={setBarcodeMode}
                                manufacturerBarcode={manufacturerBarcode}
                                onManufacturerBarcodeChange={setManufacturerBarcode}
                              /> : null}
                          </Grid>
                        </div>
                      </Grid>
                    </Grid>
                    </StyledTabPanel>

                    {/* Party Wise Report & Party Wise Price tabs disabled for now
                    <StyledTabPanel value={value} index={4} >
                    <Box sx={{ width:'100%' }} className={'c-card2'}>
                        <Grid container p={2} >
                            <Grid xs={8.9} >
                            <Select
                            className='c-text-field-4'
                            disableUnderline
                            MenuProps={{
                              PaperProps: {
                                sx: {
                                  border: "1.5px solid #e9ecf1",
                                  // width: 255,
                                  // marginLeft:'-29px !important',
                                  boxShadow: 'none',
                                  borderRadius: '5px'
                                }
                              }
                              }}
                            style={{width:200}}
                            variant='outlined'
                            sx={{
                              boxShadow: "none",
                              paddingTop:'0px !important',
                              borderRadius:'7px !important',
                              // fontSize:12,
                              '& .MuiOutlinedInput-input': {p: 0.5},
                              // '& .MuiSelect-select': { p:0 },
                              marginBottom:'3px',
                              ".MuiOutlinedInput-notchedOutline": { border: 0 },
                              "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                                {
                                  border: 0,
                                },
                              "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                                {
                                  border: 0,
                                },
                            }}
                            >
                                <MenuItem value={'0'} key={'0'}>Last Month</MenuItem>
                            </Select>
                            </Grid>

                            <Grid xs={2} pr={2}>
                            <Select
                            className='c-text-field-4'
                            disableUnderline
                            MenuProps={{
                              PaperProps: {
                                sx: {
                                  border: "1.5px solid #e9ecf1",
                                  // width: 255,
                                  // marginLeft:'-29px !important',
                                  boxShadow: 'none',
                                  borderRadius: '5px'
                                }
                              }
                              }}
                            style={{width:'100%'}}
                            variant='outlined'
                            sx={{
                              boxShadow: "none",
                              paddingTop:'0px !important',
                              borderRadius:'7px !important',
                              // fontSize:12,
                              '& .MuiOutlinedInput-input': {p: 0.5},
                              // '& .MuiSelect-select': { p:0 },
                              marginBottom:'3px',
                              ".MuiOutlinedInput-notchedOutline": { border: 0 },
                              "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                                {
                                  border: 0,
                                },
                              "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                                {
                                  border: 0,
                                },
                            }}
                            >     
                                <MenuItem value={'0'} key={'0'}>Download</MenuItem>
                            </Select>
                            </Grid>

                            <Grid xs={1.1} >
                            <Button
                                size='small'
                                variant="contained"
                                style={{ color:'#488dff',backgroundColor:'#fff',border:'0.5px solid #488dff',height:35,borderRadius:7, whiteSpace: 'nowrap'}}
                            >
                            Print PDF</Button>
                            </Grid>
                        </Grid>
                        <div style={{marginBottom:12}}>
                            <Table stickyHeader sx={{ minWidth: 700}} size='small' aria-label="customized table">
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell width={200}>Party Name</StyledTableCell>
                                    <StyledTableCell>Sales Quantity</StyledTableCell>
                                    <StyledTableCell>Sales Amount</StyledTableCell>
                                    <StyledTableCell>Purchase Quantity</StyledTableCell>
                                    <StyledTableCell>Purchase Amount</StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <StyledTableRow key={0}>
                                    <StyledTableCell>Tanmay Buradkar</StyledTableCell>   
                                    <StyledTableCell>3</StyledTableCell>   
                                    <StyledTableCell>₹ 243.22</StyledTableCell>   
                                    <StyledTableCell>1</StyledTableCell>   
                                    <StyledTableCell>₹ 100</StyledTableCell>   
                                </StyledTableRow>
                                <StyledTableRow key={1}>
                                <StyledTableCell>Tanmay Buradkar</StyledTableCell>   
                                    <StyledTableCell>3</StyledTableCell>   
                                    <StyledTableCell>₹ 243.22</StyledTableCell>   
                                    <StyledTableCell>1</StyledTableCell>   
                                    <StyledTableCell>₹ 100</StyledTableCell>   
                                </StyledTableRow>
                                <StyledTableRow key={2}>
                                <StyledTableCell>Tanmay Buradkar</StyledTableCell>   
                                    <StyledTableCell>3</StyledTableCell>   
                                    <StyledTableCell>₹ 243.22</StyledTableCell>   
                                    <StyledTableCell>1</StyledTableCell>   
                                    <StyledTableCell>₹ 100</StyledTableCell>   
                                </StyledTableRow>
                                <StyledTableRow key={3}>
                                <StyledTableCell>Tanmay Buradkar</StyledTableCell>   
                                    <StyledTableCell>3</StyledTableCell>   
                                    <StyledTableCell>₹ 243.22</StyledTableCell>   
                                    <StyledTableCell>1</StyledTableCell>   
                                    <StyledTableCell>₹ 100</StyledTableCell>   
                                </StyledTableRow>
                                <StyledTableRow key={4}>
                                <StyledTableCell>Tanmay Buradkar</StyledTableCell>   
                                    <StyledTableCell>3</StyledTableCell>   
                                    <StyledTableCell>₹ 243.22</StyledTableCell>   
                                    <StyledTableCell>1</StyledTableCell>   
                                    <StyledTableCell>₹ 100</StyledTableCell>   
                                </StyledTableRow>
                            </TableBody>
                            </Table>
                        </div>
                    </Box>
                    </StyledTabPanel>
                    <StyledTabPanel value={value} index={4} >
                    <Box sx={{ width:'100%' }} className={'c-card2'}>
                        <Grid container p={2} justifyContent="space-between" alignItems="center">
                            <Grid xs={7.2} >
                            <Select
                            className='c-text-field-4'
                            disableUnderline
                            MenuProps={{
                              PaperProps: {
                                sx: {
                                  border: "1.5px solid #e9ecf1",
                                  // width: 255,
                                  // marginLeft:'-29px !important',
                                  boxShadow: 'none',
                                  borderRadius: '5px'
                                }
                              }
                              }}
                            style={{width:200}}
                            variant='outlined'
                            sx={{
                              boxShadow: "none",
                              paddingTop:'0px !important',
                              borderRadius:'7px !important',
                              // fontSize:12,
                              '& .MuiOutlinedInput-input': {p: 0.5},
                              // '& .MuiSelect-select': { p:0 },
                              marginBottom:'3px',
                              ".MuiOutlinedInput-notchedOutline": { border: 0 },
                              "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                                {
                                  border: 0,
                                },
                              "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                                {
                                  border: 0,
                                },
                            }}
                            >
                                <MenuItem value={'0'} key={'0'}>Last Month</MenuItem>
                            </Select>
                            </Grid>

                            <Grid container xs={4.8} justifyContent="flex-end" spacing={1}>
                                <Grid item>
                                    <Button
                                        onClick={()=> setPartyPrice(true)}
                                        size='small'
                                        variant="contained"
                                        style={{ fontSize: 14, color:'#488dff',backgroundColor:'#fff',border:'0.5px solid #488dff',height:35,borderRadius:7, whiteSpace: 'nowrap'}}
                                    >
                                    Add Party Price</Button>
                                </Grid>
                                <Grid item>
                                    <Button
                                        size='small'
                                        variant="contained"
                                        style={{ color:'#488dff',backgroundColor:'#fff',border:'0.5px solid #488dff',height:35,borderRadius:7, whiteSpace: 'nowrap'}}
                                    >
                                    Print PDF</Button>
                                </Grid>
                            </Grid>
                        </Grid>
                        <div style={{marginBottom:12}}>
                            <Table stickyHeader sx={{ minWidth: 700}} size='small' aria-label="customized table">
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell>Date</StyledTableCell>   
                                    <StyledTableCell width={200}>Party Name</StyledTableCell>
                                    <StyledTableCell>Sales Price</StyledTableCell>
                                    <StyledTableCell>GST Tax Rate(%)</StyledTableCell>
                                    <StyledTableCell>Discount(%)</StyledTableCell>
                                    <StyledTableCell>Valid Upto</StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <StyledTableRow key={0}>
                                    <StyledTableCell>12/06/2003</StyledTableCell>
                                    <StyledTableCell>Tanmay Buradkar</StyledTableCell>  
                                    <StyledTableCell>₹ 243.22</StyledTableCell>   
                                    <StyledTableCell>15%</StyledTableCell>   
                                    <StyledTableCell>10%</StyledTableCell>  
                                    <StyledTableCell>20/05/2025</StyledTableCell> 
                                </StyledTableRow>
                                <StyledTableRow key={1}>
                                <StyledTableCell>12/06/2003</StyledTableCell>
                                    <StyledTableCell>Tanmay Buradkar</StyledTableCell>  
                                    <StyledTableCell>₹ 243.22</StyledTableCell>   
                                    <StyledTableCell>15%</StyledTableCell>   
                                    <StyledTableCell>10%</StyledTableCell>  
                                    <StyledTableCell>20/05/2025</StyledTableCell>   
                                </StyledTableRow>
                                <StyledTableRow key={2}>
                                <StyledTableCell>12/06/2003</StyledTableCell>
                                    <StyledTableCell>Tanmay Buradkar</StyledTableCell>  
                                    <StyledTableCell>₹ 243.22</StyledTableCell>   
                                    <StyledTableCell>15%</StyledTableCell>   
                                    <StyledTableCell>10%</StyledTableCell>  
                                    <StyledTableCell>20/05/2025</StyledTableCell> 
                                </StyledTableRow>
                                <StyledTableRow key={3}>
                                <StyledTableCell>12/06/2003</StyledTableCell>
                                    <StyledTableCell>Tanmay Buradkar</StyledTableCell>  
                                    <StyledTableCell>₹ 243.22</StyledTableCell>   
                                    <StyledTableCell>15%</StyledTableCell>   
                                    <StyledTableCell>10%</StyledTableCell>  
                                    <StyledTableCell>20/05/2025</StyledTableCell> 
                                </StyledTableRow>
                                <StyledTableRow key={4}>
                                <StyledTableCell>12/06/2003</StyledTableCell>
                                    <StyledTableCell>Tanmay Buradkar</StyledTableCell>  
                                    <StyledTableCell>₹ 243.22</StyledTableCell>   
                                    <StyledTableCell>15%</StyledTableCell>   
                                    <StyledTableCell>10%</StyledTableCell>  
                                    <StyledTableCell>20/05/2025</StyledTableCell> 
                                </StyledTableRow>
                            </TableBody>
                            </Table>
                        </div>
                        </Box>
                    </StyledTabPanel>
                    */}
                    <Box sx={{ p: 3 }} />
                </Box>
                </Grid>
                    <Grid item xs={3} style={{height:'85vh', overflow:'auto'}} mt={3} pr={1}>
                        <Grid container p={0} spacing={2} mt={-4}>
                            <Grid item xs={12}>
                            <h4>View Other Items</h4>
                            <TextField className='c-text-field-4' 
                              variant="standard" 
                              style={{width:'100%',marginTop:10}} 
                              size='small'
                              // value={filterQuery}
                              placeholder='Search Customer Name ...'
                              onChange={(e)=> searchQuery(e.target.value.toString())}
                              InputProps={{
                                disableUnderline: true,
                                startAdornment: <InputAdornment position="start"><SearchIcon style={{marginTop:-3}} size={20}/></InputAdornment>,
                                style:{ 
                                  fontSize:14,
                                  fontWeight: 'normal',
                                },
                              }} 
                            />
                            </Grid>

                            { isLoading ?
                              <>
                              {[1,2,3,4,5].map((e:any) =>
                                  <Grid item xs={12}>   
                                    <div className={'c-card2'} style={{padding:10,paddingLeft:10}}>
                                      <Grid container>
                                        <Grid item xs={3.5}>
                                        <Skeleton animation="wave" variant="circular" width={60} height={60} />
                                        </Grid>
                                        <Grid item xs={8}>
                                        <Skeleton animation="wave" height={30} />
                                        <Skeleton animation="wave" height={30} />
                                        <Skeleton animation="wave" height={30} />
                                        </Grid>
                                      </Grid>
                                    </div>
                                  </Grid>
                              )} 
                              </>
                              : (inventories && inventories.length > 0) ? inventories.map((e:any) =>
                              <Grid item xs={6} onClick={()=> navigate(`/inventory/view/${e._id}`)} key={e._id}>   
                                  <div className={'c-card2'} style={{padding:10,paddingLeft:10}}>
                                    <img src={DefaultImg} alt="" style={{objectFit:'contain',width:'100%',borderRadius:7,border:'.5px solid #e9ecf1',height:100}}/>
                                    <p style={{fontSize:13}}>{String(e.name).length > 55 ? String(e.name).substring(0,55) + '...' : String(e.name)}</p>
                                    <span style={{float:'right',fontSize:12,marginTop:2.5}}>
                                      {(e.stock && e.stock.currentStock) ? e.stock.currentStock : ''} 
                                      <span style={{color:'#9da7b7'}}>{(e.sale && e.sale.unit && e.sale.unit.code) ? e.sale.unit.code : ''}</span>
                                    </span>
                                    <h5 style={{fontWeight:'normal',color:'#000',fontSize:14}}>{(e.sale && e.sale.price) ? Utils.formatNumber(e.sale.price) : ''}</h5>
                                  </div>
                                </Grid>
                              ) :

                              <>
                                <Grid item xs={12}>   
                                  <div className={'c-card2'} style={{padding:10,paddingLeft:10}}>
                                    <Grid container>
                                      <Grid item xs={12}>
                                        <p>No records found for the query</p>
                                      </Grid>
                                    </Grid>
                                  </div>
                                </Grid>
                              </>
                            }
                        </Grid>
                  </Grid>

              
        </Grid>
      </>
    );
}
export default InventoryViewPage;